import { useState } from 'react';
import { Grid, Typography, Box, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FileUploadModel from '../../../components/fileUploadModal';
import { deletePostPicture } from '../../../redux/post/postSlice';
import { useNotification } from '../../shared/NotificationProvider';

const ImageUploadSection = ({ postImages, handleUploadFile, dispatch }) => {
  const notify = useNotification();
  const [open, setOpen] = useState(false);

  const handleDeleteClick = async (public_id) => {
    const confirmed = await notify.confirm({
      title: "Delete this image?",
      message: "This action cannot be undone. ",
    });

    if (confirmed) {
      try {
        const response = await dispatch(deletePostPicture({ public_id }));
        notify.warning(response.message || "Image deleted successfully");
      } catch (error) {
        notify.error("Failed to delete image. Please try again.");
      }
    }
  };

  return (
    <Grid item xs={12}>
      <Typography variant="subtitle1" gutterBottom sx={{ color: "#fff" }}>
        Post Images (Max 5)
      </Typography>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Box
            sx={{
              border: '2px dashed rgba(255,255,255,0.3)',
              borderRadius: '8px',
              p: 2,
              textAlign: 'center',
              cursor: 'pointer',
              backgroundColor: 'rgba(255,255,255,0.05)',
              height: 150,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              '&:hover': {
                borderColor: 'rgba(255,255,255,0.6)',
                backgroundColor: 'rgba(255,255,255,0.08)',
              },
              transition: 'all 0.2s ease',
            }}
            component="label"
          >
            <CloudUploadIcon fontSize="large" sx={{ color: 'rgba(255,255,255,0.6)' }} />
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', mt: 1 }}>
              Click or drag images to upload
            </Typography>
            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.4)' }}>
              (JPG, PNG, JPEG)
            </Typography>
            <input hidden multiple accept="image/*" onClick={() => setOpen(true)} />
            <FileUploadModel
              open={open}
              setOpen={setOpen}
              fileUploadProps={{ maxNumber: 5 }}
              handleUploadFile={handleUploadFile}
            />
          </Box>
        </Grid>

        {postImages?.length > 0 && (
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, color: "rgba(255,255,255,0.7)" }}>
              Uploaded Images ({postImages?.length}/5)
            </Typography>
            <Grid container spacing={2}>
              {postImages?.map((imgObj, index) => (
                <Grid item xs={6} sm={4} md={3} key={index}>
                  <Box
                    sx={{
                      position: 'relative',
                      height: 200,
                      borderRadius: 2,
                      overflow: 'hidden',
                      boxShadow: 1,
                      '&:hover .delete-btn': { opacity: 1 }
                    }}
                  >
                    <img
                      src={imgObj.url}
                      alt={`Home pic ${index + 1}`}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                    <IconButton
                      className="delete-btn"
                      onClick={() => handleDeleteClick(imgObj.public_id)}
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        height: '30px',
                        width: '30px',
                        backgroundColor: 'rgba(255,255,255,0.8)',
                        opacity: 0,
                        transition: 'opacity 0.2s',
                        '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
                      }}
                      size="small"
                    >
                      <DeleteIcon fontSize="small" color="error" />
                    </IconButton>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default ImageUploadSection;
